import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class SupplierEndpoints {
  constructor(private http: HttpClient) {}
}
